module.exports = __webpack_public_path__ + "acf59141e030da6f20cee64a169d61ac.jpg";